module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "black-back"
  }, [(_vm.scoreStatus == 'add') ? _c('van-notice-bar', {
    staticStyle: {
      "z-index": "10000"
    },
    attrs: {
      "text": "   裁判长提醒您，打分偏差过大，请向上调分。"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scoreStatus == 'pen') ? _c('van-notice-bar', {
    staticStyle: {
      "z-index": "10000"
    },
    attrs: {
      "text": "   裁判长提醒您，打分偏差过大，请向下调分。"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "score-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-title"
  }, [_vm._v(_vm._s(_vm.row.saiqu_name) + " " + _vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child"
  }, [_vm._v(_vm._s(_vm.row.subject.subject_name))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child",
    on: {
      "click": function($event) {
        _vm.peopleShow = true
      }
    }
  }, [_vm._v(_vm._s(_vm.row.subject.mingcheng))])]), _vm._v(" "), _c('div', {
    staticClass: "score-content"
  }, [_c('div', {
    staticClass: "score-content-left"
  }, [_c('div', {
    staticClass: "score-value-box"
  }, [_c('div', {
    staticClass: "score-value-text flex-between"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex-start",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onRefresh
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "replay"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("刷新")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-content flex-center"
  }, [_vm._v(_vm._s(_vm.formData.score > 0 ? _vm.formData.score : '--') + "\n"), (_vm.scoreStatus == 'pen') ? _c('van-icon', {
    staticStyle: {
      "transform": "rotate(90deg)"
    },
    attrs: {
      "name": "play",
      "color": "#0dac0d"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scoreStatus == 'add') ? _c('van-icon', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "name": "play",
      "color": "#ff0000"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "score-comment-box"
  }, [_c('div', {
    staticClass: "score-comment-head flex-between"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "score-comment-head-right",
    on: {
      "click": _vm.onComment
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/comment-edit.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "score-comment-text"
  }, _vm._l((_vm.commentResult), function(cvalue, cindex) {
    return _c('van-tag', {
      key: cindex,
      staticStyle: {
        "margin": "0 10px 10px 0"
      },
      attrs: {
        "closeable": ""
      },
      on: {
        "click": function($event) {
          return _vm.commentClose(cindex)
        },
        "close": function($event) {
          return _vm.commentClose(cindex)
        }
      }
    }, [_vm._v(_vm._s(cvalue.name))])
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "score-caipan-box score-caipan-online"
  }, [_c('div', {
    staticClass: "score-caipan-value flex-between"
  }, [_c('div', {
    staticClass: "score-caipan-left flex-start"
  }, [_c('div', {
    staticClass: "caipan-button",
    staticStyle: {
      "padding": "5px 10px 5px 0"
    },
    on: {
      "click": _vm.toLoginOutAuto
    }
  }, [_vm._v("退出")]), _vm._v(" "), _c('div', {
    staticClass: "caipan-name"
  }, [_vm._v(" " + _vm._s(_vm.row.caipan.jgroup == 1 ? 'B组裁判' + '-' + (_vm.row.caipan.index + 1) + '-' + _vm.row.caipan.name :
    'A组裁判' + '-' + (_vm.row.caipan.index + 1) + '-' + _vm.row.caipan.name) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "score-caipan-right"
  }, [_vm._v("网络正常")])])])]), _vm._v(" "), _c('div', {
    staticClass: "score-content-right flex-start"
  }, [_c('div', {
    staticClass: "key-left"
  }, [_c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(2)
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(3)
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(4)
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(5)
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(6)
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(7)
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(8)
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(9)
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "key-li-full",
    on: {
      "click": function($event) {
        return _vm.onKey(0)
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey('.')
      }
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "key-right"
  }, [_c('div', {
    staticClass: "key-delete flex-center",
    on: {
      "click": function($event) {
        return _vm.onKey('delete')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/score-delete.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.row.caipan.jgroup === _vm.row.subject.jgroup && !_vm.scoreCurrent || _vm.scoreStatus) ? _c('div', {
    staticClass: "key-button flex-center",
    staticStyle: {
      "background": "#1989FA",
      "color": "#fff"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交\n          ")]) : _c('div', {
    staticClass: "key-button flex-center",
    staticStyle: {
      "background": "#44D7B6",
      "color": "#fff",
      "cursor": "not-allowed"
    }
  }, [_vm._v("完成\n          ")])])])]), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('div', [_vm._v("that.formData: || " + _vm._s(_vm.formData))]), _vm._v(" "), _c('div', [_vm._v("row.caipan: || " + _vm._s(_vm.row.caipan.jgroup))]), _vm._v(" "), _c('div', [_vm._v("row.subject: || " + _vm._s(_vm.row.subject.jgroup))]), _vm._v(" "), _c('div', [_vm._v("scoreStatus: || " + _vm._s(_vm.scoreStatus))]), _vm._v(" "), _c('div', [_vm._v("dataAll: || " + _vm._s(_vm.dataAll))]), _vm._v(" "), _c('div', [_vm._v("scoreCurrent: || " + _vm._s(_vm.scoreCurrent))])]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.peopleShow),
      callback: function($$v) {
        _vm.peopleShow = $$v
      },
      expression: "peopleShow"
    }
  }, [_c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "people-title"
  }, [_vm._v("运动员")]), _vm._v(" "), _c('div', {
    staticClass: "people-content"
  }, [_vm._v(_vm._s(_vm.row.subject.yundongyuans))])])]), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '90%',
      right: 0,
      width: '100%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.commentShow),
      callback: function($$v) {
        _vm.commentShow = $$v
      },
      expression: "commentShow"
    }
  }, [_c('div', {
    staticClass: "comment-selector"
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "is-link": "",
      "label": "项目分类",
      "placeholder": "请选择项目分类"
    },
    on: {
      "click": function($event) {
        _vm.showCommentSubjectPicker = true
      }
    },
    model: {
      value: (_vm.commentSubject),
      callback: function($$v) {
        _vm.commentSubject = $$v
      },
      expression: "commentSubject"
    }
  })], 1), _vm._v(" "), _c('van-tabs', {
    on: {
      "change": _vm.subSubjectChange
    },
    model: {
      value: (_vm.subSubjectValue),
      callback: function($$v) {
        _vm.subSubjectValue = $$v
      },
      expression: "subSubjectValue"
    }
  }, _vm._l((_vm.subSubjectTabs), function(tvalue, tindex) {
    return _c('van-tab', {
      key: tindex,
      attrs: {
        "title": tvalue
      }
    })
  }), 1), _vm._v(" "), (_vm.commentOptions.length > 0) ? _c('van-cell-group', _vm._l((_vm.commentOptions), function(item, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "clickable": ""
      },
      on: {
        "click": function($event) {
          return _vm.commentToggle(item)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "custom-title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('van-checkbox', {
      attrs: {
        "slot": "right-icon",
        "checked-color": "#FD2840"
      },
      slot: "right-icon",
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 2)
  }), 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showCommentSubjectPicker),
      callback: function($$v) {
        _vm.showCommentSubjectPicker = $$v
      },
      expression: "showCommentSubjectPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.commentSubjectcolumns
    },
    on: {
      "confirm": _vm.onCommentSubjectComfirm
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "position": "fixed",
      "bottom": "10px",
      "right": "400px"
    },
    on: {
      "click": function($event) {
        _vm.commentShow = false;
        _vm.commentResult = []
      }
    }
  }, [_vm._v("清除并取消")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "position": "fixed",
      "bottom": "10px",
      "right": "200px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.commentShow = false;
      }
    }
  }, [_vm._v("我选好了")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-logo"
  }, [_c('div', {
    staticClass: "score-logo-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("分值")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-comment-head-left flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("评语")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dba8884c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/CommonScore.vue
// module id = 2610
// module chunks = 0